import React, { memo } from "react";
import { Routes, Route } from "react-router-dom";
import Landing from "../pages/Landing";
import InputForm from "../InputForm/InputForm";
// import Constraints from "../InputForm/ConstraintsOld";
import Output from "../Output/Output";
import NotFound from "../NotFound/NotFound";
import History from "../History/History";
import Login from "../Auth/Login";
import Register from "../Auth/Register";
import ForgotPassword from "../Auth/ForgotPassword";
import ResetPassword from "../Auth/ResetPassword";
import UpgradeRole from "../../components/AdminPanel/UpgradeRole";
import AdminPanel from "../../components/AdminPanel/index";
import AuthProvider from "../HOC/AuthProvider";
import Bounds from "../InputForm/Bounds/Bounds";
import Deviations from "../Deviations/Deviations";
import ErpConverter from "../ErpConverter/ErpConverter";
import HomeStepper from "../Stepper/HomeStepper";
import AssumptionsOnStep0 from "../Stepper/AssumptionsOnStep0";
import { EditAssumptions } from "../Stepper/EditAssumptions/EditAssumptions";

const MainRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthProvider>
            <Landing />
          </AuthProvider>
        }
      >
        <Route path="/" element={<HomeStepper />} />
        <Route path="/editAssumptions" element={<EditAssumptions />} />
        <Route path="/convert_erp" element={<ErpConverter />} />
        <Route path="/generate" element={<InputForm />} />
        <Route path="/constraints" element={<Bounds />} />
        <Route path="/output" element={<Output />} />
        <Route path="/deviations" element={<Deviations />} />
        <Route path="/history" element={<History />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/upgrade" element={<UpgradeRole />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default memo(MainRoutes);
